import { useMutation } from "@tanstack/react-query";
import axios from "../services/axios/backendAxios";
import flash from "../services/flash";
import errors from "../services/errors";

export function useApplyCouponCodeMutation() {
  return useMutation({
    mutationFn: async ({ promotionCode, subscriptionId }) => {
      await axios.post("stripe/subscription/apply-coupon", {
        subscriptionId,
        promotionCode: promotionCode,
      });
    },
    onSuccess: () => {
      flash.success(
        "Coupon applied!  The changes will appear on your next invoice.",
      );
    },
    onError: (err) => {
      errors.report(err);
      flash.error("Error: " + (err.message ?? err));
    },
  });
}
